var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconImport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 11.4C1.52614 11.4 1.75 11.6239 1.75 11.9V14.4C1.75 14.9523 2.19772 15.4 2.75 15.4H14.75C15.3023 15.4 15.75 14.9523 15.75 14.4V11.9C15.75 11.6239 15.9739 11.4 16.25 11.4C16.5261 11.4 16.75 11.6239 16.75 11.9V14.4C16.75 15.5046 15.8546 16.4 14.75 16.4H2.75C1.64543 16.4 0.75 15.5046 0.75 14.4V11.9C0.75 11.6239 0.973858 11.4 1.25 11.4Z",
    fill: "#2362A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.39645 2.64645C8.59171 2.45118 8.90829 2.45118 9.10355 2.64645L12.1036 5.64645C12.2988 5.84171 12.2988 6.15829 12.1036 6.35355C11.9083 6.54882 11.5917 6.54882 11.3964 6.35355L9.25 4.20711V13C9.25 13.2761 9.02614 13.5 8.75 13.5C8.47386 13.5 8.25 13.2761 8.25 13V4.20711L6.10355 6.35355C5.90829 6.54882 5.59171 6.54882 5.39645 6.35355C5.20118 6.15829 5.20118 5.84171 5.39645 5.64645L8.39645 2.64645Z",
    fill: "#2362A2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImport);
export default __webpack_public_path__ + "static/media/icon_import.1cf5d464fe477a2a196a6a73b00115a8.svg";
export { ForwardRef as ReactComponent };